import ApiService from "@services/api.service";
import TokenService from "@services/token.service";
import StorageService from '@services/storage.service';

export default {
    namespaced: true,

    state: {
        status: '',
        token: TokenService.getToken() || '',
        user: StorageService.getItem('user', true, true) || {},
        roles: StorageService.getItem('roles', true, true) || {},
        permissions: StorageService.getItem('permissions', true, true) || {}
    },

    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    },

    actions: {
        login({
            commit
        }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')

                ApiService.post('/login', user)
                    .then(resp => {
                        const data = resp.data;

                        // Save token to storage
                        TokenService.saveToken(data.access_token);

                        // Refresh header with new token
                        ApiService.setAuthHeader();

                        // Save user, roles, permissions to storage
                        StorageService.saveItem('user', data.user);
                        StorageService.saveItem('roles', data.roles);
                        StorageService.saveItem('permissions', data.permissions);

                        commit('auth_success');
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')

                        // Remove user from storage
                        StorageService.removeItem('user');

                        // Remove token from local storage
                        TokenService.removeToken();

                        reject(err)
                    })
            })
        },

        register({
            commit
        }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')

                ApiService.post('/register', user)
                    .then(resp => {
                        const data = resp.data;

                        // Save token to storage
                        TokenService.saveToken(data.access_token);

                        // Refresh header with new token
                        ApiService.setAuthHeader();

                        // Save user to storage
                        StorageService.saveItem('user', data.user);

                        commit('auth_success', data)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error', err)

                        // Remove user from storage
                        StorageService.removeItem('user');

                        // Remove token from local storage
                        TokenService.removeToken();

                        reject(err)
                    })
            })
        },

        logout({
            commit
        }) {
            return new Promise((resolve, reject) => {
                commit('logout')

                ApiService.post('/logout')
                    .then(res => {
                        // Remove user from storage
                        StorageService.removeItem('user');
                        StorageService.removeItem('roles');
                        StorageService.removeItem('permissions');

                        // Remove token from storage
                        TokenService.removeToken();

                        // Remove token from header
                        ApiService.removeAuthHeader();

                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
        }
    },

    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state) {
            state.status = 'success';
            state.token = TokenService.getToken();
            state.user = StorageService.getItem('user', true, true);
            state.roles = StorageService.getItem('roles', true, true);
            state.permissions = StorageService.getItem('permissions', true, true);
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
            state.user = {}
            state.roles = {}
            state.permissions = {}
        }
    }
}
